<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getFileInfo } from '@chatwoot/utils';

import FileIcon from 'next/icon/FileIcon.vue';
import Icon from 'next/icon/Icon.vue';
import MiddleTruncate from 'next/polaris/cards/MiddleTruncate.vue';
import { ON_BUBBLE } from 'next/polaris/skin/onBubble';

const { attachment } = defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const fileDetails = computed(() => {
  return getFileInfo(attachment?.dataUrl || '');
});
</script>

<template>
  <!-- Polaris skin: the chip is a tint of the bubble it sits on, and the name
       is cut in the middle, the kit's rule, so the extension and a revision
       at the end survive. The type is told by the icon, not by a text color. -->
  <div
    class="h-9 gap-2 overflow-hidden items-center flex px-2 rounded-polaris-lg border"
    :class="[ON_BUBBLE.surface, ON_BUBBLE.border]"
  >
    <FileIcon class="flex-shrink-0" :file-type="fileDetails.type" />
    <MiddleTruncate
      class="flex-1 max-w-48 type-polaris-body"
      :text="fileDetails.name"
    />
    <a
      v-tooltip="t('CONVERSATION.DOWNLOAD')"
      class="flex-shrink-0 size-9 grid place-content-center cursor-pointer transition-opacity"
      :class="ON_BUBBLE.quiet"
      :href="attachment.dataUrl"
      rel="noreferrer noopener nofollow"
      target="_blank"
    >
      <Icon icon="i-lucide-download" />
    </a>
  </div>
</template>
